import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateCookiePreference } from '@/redux/cookieSlice';
import { IOSSwitch } from './Switch';

export const ContentItem = ({ item }: { item: any }) => {
  const dispatch = useDispatch();
  const preferences = useSelector((state: any) => state.cookie.preferences);

  const getSwitchValue = () => {
    if (item.name && preferences[item.name] !== undefined) {
      return preferences[item.name];
    }
    return item.needConfirm === 2; // 默认值
  };

  const handleSwitchChange = (checked: boolean) => {
    if (item.name) {
      dispatch(updateCookiePreference({ type: item.name, value: checked }));
    }
  };

  return (
    <>
      <div className="flex items-center justify-between text-lg lg:py-4">
        <div className="font-medium lg:font-normal">{item.title}</div>
        <div>
          {item.needConfirm === 0 ? (
            false
          ) : item.needConfirm === 1 ? (
            <div className="text-sm capitalize text-[#5E00FF]">
              always active
            </div>
          ) : (
            <div>
              <IOSSwitch
                sx={{ m: 1 }}
                checked={getSwitchValue()}
                onChange={(e) => {
                  handleSwitchChange(e.target.checked);
                }}
              />
            </div>
          )}
        </div>
      </div>
      <div className="h-full overflow-auto text-sm capitalize">
        {item.content}
      </div>
    </>
  );
};
